// extracted by mini-css-extract-plugin
export default {"container":"ButtonWithIcon_container__SMark","icon":"ButtonWithIcon_icon__HN6Dl","text":"ButtonWithIcon_text__IfeVQ"};